/* eslint-disable sort-keys */
/* eslint-disable max-statements */
import React, { createContext, useContext, useMemo, useState } from 'react'
import { postUpgradePlanoAPI } from '../api/upgrade.servico'
import { useGlobal } from './GlobalContext'
import { isEmptyObject, objetoTemPropriedade } from '../utils/helpers/helpers'
import { httpStatus, textoModalErro } from '../utils/request/httpStatus'
import { METODO_PAGAMENTO_CARTAO, METODO_PAGAMENTO_PIX, PLANO_ANUAL } from '../constants'
import { ETAPA_BRINDES, ETAPA_CONCLUSAO, ETAPA_ENTREGA, ETAPA_PAGAMENTO } from '../components/FluxosPagamento/constantsFluxosPagamento'
import {
  BASES_OBRIGATORIAS_UPGRADE,
  BASES_OPCIONAIS_UPGRADE,
  BASE_PROPRIEDADE_ASSINATURA_UPGRADE,
  BASE_PROPRIEDADE_BRINDE_UPGRADE,
  BASE_PROPRIEDADE_ENTREGA_UPGRADE,
  BASE_PROPRIEDADE_PAGAMENTO_UPGRADE,
  BASE_PROPRIEDADE_PAGAMENTO_CARTAO_UPGRADE,
  BASE_PROPRIEDADE_CUPONS_UPGRADE
} from '../containers/Modalidade/Plano/Upgrade/constantsUpgradePlano'
import { upgradeEvent, userDataEvent } from '../utils/events/events'
import { rdUpgradeEvent } from '../utils/events/eventsRdStation'
import { getDadosAssociado } from '../api/associado.servico'

const UpgradePlanoContext = createContext()

function UpgradePlanoProvider( props ) {
  const [ state, setState ] = useState( {
    'dadosRetornoRequisicao': null,
    'loadingUpgrade': false,
    'sucessoUpgrade': false,
    'tipoPagamentoUpgrade': null
  } )

  const value = useMemo( () => {
    return {
      setState,
      state
    }
  }, [ state ] )

  return (
    <UpgradePlanoContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function useUpgradePlano() {
  const context = useContext( UpgradePlanoContext )
  if ( !context ) {
    throw new Error( 'useUpgradePlano deve ser usado dentro de um UpgradePlanoProvider' )
  }

  const { state, setState } = context
  const { setErroRequisicao } = useGlobal()

  const setSucessoUpgrade = sucesso => {
    setState( prevState => ( {
      ...prevState,
      'sucessoUpgrade': sucesso
    } ) )
  }

  const setTipoPagamentoUpgrade = pagamento => {
    setState( prevState => ( {
      ...prevState,
      'tipoPagamentoUpgrade': pagamento
    } ) )
  }

  const setLoadingUpgrade = loading => {
    setState( prevState => ( {
      ...prevState,
      'loadingUpgrade': loading
    } ) )
  }

  const setDadosRetornoRequisicao = dados => {
    setState( prevState => ( {
      ...prevState,
      'dadosRetornoRequisicao': dados
    } ) )
  }

  const postUpgradePlano = async( assinatura, dadosUpgrade ) => {
    let objetoFinal
    let isPagamentoCartao
    let isPagamentoPix
    setLoadingUpgrade( true )
    Object.entries( dadosUpgrade ).forEach( upgrade => {
      const [ chave, objeto ] = upgrade
      if ( !isEmptyObject( objeto ) ) {
        if ( chave === ETAPA_BRINDES ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_BRINDE_UPGRADE ]: objeto.id
          }
        }

        if ( chave === ETAPA_ENTREGA ) {
          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_ENTREGA_UPGRADE ]: { 'id': dadosUpgrade[ chave ].id ? Number( dadosUpgrade[ chave ].id ) : null }
          }
        }

        if ( chave === ETAPA_PAGAMENTO ) {
          const hasParcelaCartaoCredito = objetoTemPropriedade( dadosUpgrade[ chave ], 'parcela' ) ? dadosUpgrade[ chave ].parcela : 0
          const hasPromocao = objetoTemPropriedade( dadosUpgrade[ chave ], 'promocao' ) && !isEmptyObject( dadosUpgrade[ chave ].promocao ) ? dadosUpgrade[ chave ].promocao.codigo : null

          if ( dadosUpgrade[ chave ].metodoPagamento === METODO_PAGAMENTO_CARTAO.slug ) {
            isPagamentoCartao = true
            isPagamentoPix = false
          } else if ( dadosUpgrade[ chave ].metodoPagamento === METODO_PAGAMENTO_PIX.slug ) {
            isPagamentoCartao = false
            isPagamentoPix = true
          }

          if ( hasPromocao ) {
            objetoFinal = {
              ...objetoFinal,
              [ BASE_PROPRIEDADE_CUPONS_UPGRADE ]: [ hasPromocao ]
            }
          }

          const getIdBackendMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return Number( dadosUpgrade[ chave ].id )
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.idBackend
            }
          }

          const getTipoMetodoPagamento = () => {
            if ( isPagamentoCartao ) {
              return METODO_PAGAMENTO_CARTAO.slugBackend
            } else if ( isPagamentoPix ) {
              return METODO_PAGAMENTO_PIX.slugBackend
            }
          }

          objetoFinal = {
            ...objetoFinal,
            [ BASE_PROPRIEDADE_PAGAMENTO_UPGRADE ]: {
              [ BASE_PROPRIEDADE_PAGAMENTO_CARTAO_UPGRADE ]: {
                'cvv': isPagamentoCartao ? dadosUpgrade[ ETAPA_CONCLUSAO ].confirmacaoCVV : '',
                'id': getIdBackendMetodoPagamento()
              },
              'parcelas': isPagamentoCartao ? hasParcelaCartaoCredito : PLANO_ANUAL.parcelas,
              'tipo': getTipoMetodoPagamento()
            }
          }
        }

        if ( !isEmptyObject( assinatura ) ) {
          objetoFinal = { ...objetoFinal, [ BASE_PROPRIEDADE_ASSINATURA_UPGRADE ]: assinatura.id }
        }
      }
    } )

    const podeFazerUpgrade = Object.keys( objetoFinal )
      .every( chave => BASES_OBRIGATORIAS_UPGRADE.includes( chave ) || BASES_OPCIONAIS_UPGRADE.includes( chave ) )

    if ( podeFazerUpgrade ) {
      try {
        const { 'data': dados } = await postUpgradePlanoAPI( objetoFinal )
        if ( !isEmptyObject( dados.assinatura ) ) {
          setSucessoUpgrade( true )
          setDadosRetornoRequisicao( dados.assinatura )
          const dadosAssociado = ( await getDadosAssociado() ).data
          userDataEvent( {
            'email': dadosAssociado.email,
            'phone': dadosAssociado.telefone,
            'name': `${dadosAssociado.nome} ${dadosAssociado.sobrenome}`,
            'userId': dadosAssociado.id,
            'productPrice': dados.venda.pagamento.valor.kit,
            'freightPrice': dados.venda.pagamento.valor.frete,
            'totalDiscount': dados.venda.pagamento.desconto.total,
            'paymentHash': dados.venda.pagamento.cobrancas[ 0 ].hash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_UPGRADE ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_UPGRADE ][ 0 ] : null,
            'planId': dados.venda.plano.id,
          } )
          upgradeEvent( {
            'paymentMethod': objetoFinal.pagamento.tipo,
            'productPrice': dados.venda.pagamento.valor.kit,
            'freightPrice': dados.venda.pagamento.valor.frete,
            'totalDiscount': dados.venda.pagamento.desconto.total,
            'paymentHash': dados.venda.pagamento.cobrancas[ 0 ].hash,
            'promotionCoupon': objetoFinal[ BASE_PROPRIEDADE_CUPONS_UPGRADE ] ? objetoFinal[ BASE_PROPRIEDADE_CUPONS_UPGRADE ][ 0 ] : null,
            'planId': dados.venda.plano.id,
          } )
          rdUpgradeEvent( {
            'planId': dados.venda.plano.id,
            'email': dadosAssociado.email,
          } )
        }
      } catch ( erros ) {
        setLoadingUpgrade( false )
        setSucessoUpgrade( false )
        if ( erros && ( erros.request || erros.response ) ) {
          if ( erros.request ) {
            setErroRequisicao( erros.request.status )
          }
          if ( erros.response ) {
            const isBadRequest = erros.response.status === httpStatus.BAD_REQUEST
            const temDetalhe = isBadRequest && erros.response.data?.errors?.length

            const descricao = temDetalhe ?
              {
                'descricao': erros.response.data.errors[ 0 ].message,
                'titulo': textoModalErro[ httpStatus.BAD_REQUEST ].titulo,
              } : {}
            setErroRequisicao( erros.response.status, descricao )
          }
        }
      }
    }
  }

  return {
    'dadosRetornoRequisicao': state.dadosRetornoRequisicao,
    'loadingUpgrade': state.loadingUpgrade,
    postUpgradePlano,
    setTipoPagamentoUpgrade,
    'sucessoUpgrade': state.sucessoUpgrade,
    'tipoPagamentoUpgrade': state.tipoPagamentoUpgrade,
    setLoadingUpgrade
  }
}

export { UpgradePlanoProvider, useUpgradePlano }
